<template>
  <label class="el-checkbox row" :class="{'is-checked': isChecked }"
  @click="handleChange">
    <span class="el-checkbox__input" :class="{'is-checked': isChecked }">
      <span class="el-checkbox__inner"></span>
    </span>
  </label>
</template>

<script>
export default {
  model: {
    prop: 'checked',
    event: 'click'
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    name: {
      type: String | Object
    },
    ids: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    }
  },
  computed: {
    isChecked() {
      if (this.ids && this.name) {
        return !!this.ids.includes(this.name)
      } else {
        return this.checked
      }
    }
  },
  watch: {

  },
  methods: {
    handleChange(e) {
      e.preventDefault()
      let {
        name,
        ids
      } = this
      if (name && ids) {
        const index = ids.indexOf(name)
        if (index >= 0) {
          ids.splice(index, 1)
          this.isChecked = false
        } else {
          this.isChecked = true
          ids.push(name)
        }
        this.$emit('update:ids', ids)
      } else {
        this.checked = !this.checked
        this.$emit('click', this.checked)
      }
    }
  }
}
</script>

<style scoped>
.el-checkbox {
  margin-right: 0;
}
</style>
